/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type LogTabContainer_user$ref: FragmentReference;
export type LogTabContainer_user = {|
  +id: string,
  +$refType: LogTabContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "LogTabContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '6fa1db8df0de1d3467b7dfc64de4d82d';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Dashboard/__generated__/LogTabContainer_user.graphql.js